export default "/images/burger-menu.svg?a91563efbd860cbfb9ea4b50f34f0b30";